import { format } from 'date-fns';
import { DATE_FORMAT_COMPACT } from '@/shared/config';
import type { PaidInvoicesParams } from '../api';
import type { PaidInvoicesFormValues } from '../model';

const buildPaidInvoicesParams = (
  data: PaidInvoicesFormValues
): PaidInvoicesParams => {
  const baseParams = { lang: data.lang };

  if (data.datefilter === 'custom') {
    if (!data.datefrom || !data.dateto) return baseParams;

    return {
      ...baseParams,
      datefrom: format(data.datefrom, DATE_FORMAT_COMPACT),
      dateto: format(data.dateto, DATE_FORMAT_COMPACT),
    };
  }

  if (data.datefilter) {
    return { ...baseParams, datefilter: data.datefilter };
  }

  return baseParams;
};

export { buildPaidInvoicesParams };
